/** Amounts in cents as the app shows them: „12,50 €“; nothing rounds to „−0,00 €“ (A4). */
export function formatEuro(cents: number): string {
  // −0 and −0.4 cents round to −0, which toLocaleString writes with a minus.
  const whole = Math.round(cents) || 0;
  return (whole / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
}
